module.exports = __webpack_public_path__ + "media/images/icons/tiktok-f629f2794da7a819aee0f92ba1b11383.svg";